





















































































import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'

export default Vue.extend({
  name: 'FreeChecksOverModal',
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogStatus: false
    }
  },
  computed: {
    ...mapGetters('results', ['getChecksCounter']),
    formLink () : string {
      const locale = this.$i18n.locale

      if (locale === '') {
        return 'https://account.truora.com/account#/es/quiz'
      }

      return `https://account.truora.com/account#/${locale}/quiz`
    }
  },
  methods: {
    ...mapMutations(['updateModalStatus'])
  },
  model: {
    prop: 'dialog',
    event: 'changeState'
  },
  watch: {
    dialogStatus () {
      this.$emit('changeState', this.dialogStatus)
      this.updateModalStatus(this.dialogStatus)
    },
    dialog () {
      this.dialogStatus = this.dialog
    }
  },
  mounted () {
    this.dialogStatus = this.dialog
  }
})
